function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let _ = (t)=>t, t;
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Header } from 'components/header';
import RichTextMarkdown from 'components/richTextMarkdown/RichTextMarkdown';
import { Link, ResponsiveProvider, RichText, useTheme } from 'features/fabric';
import { getShowHamburgerMenu } from 'features/searchCompare/state/menu';
import { getFeatureFlag } from 'framework/globalStorage/settingsStore';
import { useAppSelector } from 'framework/store/hooks';
import { useContext, useMemo } from 'react';
import styles from './HeaderMessage.scss';
const HeaderMessage = ({ isHomePage, showBanner, headerBanner, closeBanner })=>{
    const breakpoints = useContext(ResponsiveProvider.Context);
    const showHamburgerMenu = useAppSelector(getShowHamburgerMenu);
    const addNoFollow = getFeatureFlag('add_nofollow_to_header_banner_links');
    const theme = useTheme();
    const components = useMemo(()=>{
        const LinkRenderer = (_param)=>{
            var { children } = _param, props = _object_without_properties(_param, [
                "children"
            ]);
            const href = props === null || props === void 0 ? void 0 : props.href;
            return /*#__PURE__*/ _jsx(Link, {
                href: href,
                rel: addNoFollow ? 'nofollow' : undefined,
                target: "_blank",
                children: children
            });
        };
        return {
            a: LinkRenderer
        };
    }, [
        addNoFollow
    ]);
    if (showBanner && headerBanner && !showHamburgerMenu) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.bannerWrapper,
            children: /*#__PURE__*/ _jsx(Header.Banner, _object_spread_props(_object_spread({
                background: headerBanner.backgroundColor,
                color: headerBanner.color,
                onClose: closeBanner
            }, isHomePage && {
                style: {
                    height: '56px'
                }
            }), {
                children: /*#__PURE__*/ _jsx(RichText, {
                    as: RichTextMarkdown,
                    components: components,
                    sx: css(t || (t = _`
              text-wrap: wrap;
              max-width: none;

              p,
              a {
                font-size: ${0};
                line-height: ${0};
                font-weight: ${0};
                color: ${0};
              }
            `), theme.textSize.s, theme.textLineHeight.s, theme.fontWeight.bold, headerBanner.color),
                    children: breakpoints.m ? headerBanner.text : headerBanner.shortText
                })
            }))
        });
    }
    return null;
};
export default HeaderMessage;
